import React, { useEffect, useState } from 'react';
import { Editor } from '@meitu/saas-editor-core';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import DynamicBgLayerContent, { type DynamicBgLayerMode } from './dynamic-bg-layer-content';

interface IDynamicBgLayerProps {
    editor: Editor;
    /** 不传时跟随当前激活 Frame，保留演示页原有行为 */
    frameId?: number;
    /** 兼容原调用签名；实际是否渲染由 backgroundLayer.dynamicInfo 决定 */
    isAiPPT?: boolean;
    mode?: DynamicBgLayerMode;
}

const DynamicBgLayer: React.FC<IDynamicBgLayerProps> = ({ editor, frameId, mode = 'live' }) => {
    const [backgroundLayer, setBackgroundLayer] = useState<ILayerProps | null>(() => {
        const targetFrameId = frameId ?? editor.services.frame.getActiveFrameId();
        return editor.services.frame.getBackgroundLayer(targetFrameId) ?? null;
    });
    const [size, setSize] = useState(() => {
        const targetFrameId = frameId ?? editor.services.frame.getActiveFrameId();
        return editor.services.frame.getSize(targetFrameId);
    });

    useEffect(() => {
        const getFrameId = () => frameId ?? editor.services.frame.getActiveFrameId();
        const sync = () => {
            const targetFrameId = getFrameId();
            setBackgroundLayer(editor.services.frame.getBackgroundLayer(targetFrameId) ?? null);
            setSize(editor.services.frame.getSize(targetFrameId));
        };
        sync();

        const layerHandler = backgroundLayer?.id ? editor.services.flatLayer.onChange(sync, backgroundLayer.id) : null;
        const resizeHandler = editor.services.frame.onResize((resizeFrameId) => {
            if (resizeFrameId === getFrameId()) sync();
        });
        const activeHandler = frameId === undefined ? editor.services.frame.onActiveIndexChange(sync) : null;

        return () => {
            if (layerHandler !== null) editor.off(layerHandler);
            editor.off(resizeHandler);
            if (activeHandler !== null) editor.off(activeHandler);
        };
    }, [editor, frameId, backgroundLayer?.id]);

    return (
        <DynamicBgLayerContent width={size.width} height={size.height} backgroundLayer={backgroundLayer} mode={mode} />
    );
};

export default DynamicBgLayer;
